export default () => ({
  passwordToggle: {
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  error: {
    display: 'block',
  },
});
